import { Item } from 'devextreme-react/tab-panel';
import UserAgreementsTable from '../../../../user/tables/UserAgreementsTable';

interface IUserAgreementsTabParameters {
    title: string;
    principalId: number;
}

export const UserAgreementsTab: React.FC<IUserAgreementsTabParameters> = ({ title, principalId }) => {
    return (
        <Item title={title}>
            <div
                style={{
                    width: '100%',
                    minHeight: '700px',
                }}
            >
                <UserAgreementsTable id={principalId} />
            </div>
        </Item>
    );
};
